export default __webpack_public_path__ + "static/media/Img100.dfd36705.jpg";